function register(){
    // $('.schedule-call-btn').click(function(){
        window.location = '/contact';
    // }); 
}